<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h6>Клиент</h6>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>Имя клиента</label>
          <input type="text" v-model="newData.client.name" placeholder="ФИО" class="form-control">
        </div>
        <label>Номер телефона</label>
        <input type="text" v-model="newData.client.phone_num" placeholder="999 999 999" class="form-control">
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h6>Препарат</h6>
      </div>
      <div class="card-body">
        <div class="form-group">
          <div class="alert-info pt-1"><strong>Тип запроса</strong></div>
          <select v-model="newData.type_id" class="form-control">
            <option v-for="t in requestTypes" :value="t.id">{{ t.title }}</option>
          </select>
        </div>
        <div class="form-group" v-if="+newData.type_id === 4">
          <label>Город клиента</label>
          <select v-model="newData.city_id" class="form-control">
            <option disabled value="0">Выберите город клиента</option>
            <option v-for="t in sortArray($AllCities, 'name')" :value="t.id">{{ t.name }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Препарат в системе</label>
          <DrugSearchNew ref="drugSearch" :onSelect="(d) => newData.drug.id = d?.id"/>
        </div>
        <div class="form-group">
          <label>Новый препарат</label>
          <input type="text" v-model="newData.drug.title" placeholder="Название препарата" class="form-control">
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <textarea class="form-control" v-model="newData.comment" placeholder="комментарий к записи" rows="4"/>
      </div>
    </div>
    <div class="text-right mt-2">
      <!--        placement="bottom"-->
      <v-popover
        class="d-inline"
        :auto-hide="true"
      >
        <button class="btn btn-outline-success" type="button">Сохранить</button>
        <template slot="popover">
          <div class="p-2">
            <div class="form-group">
              <div class="alert alert-info p-1 mb-1"><strong>Проверьте тип запроса</strong></div>
              <select v-model="newData.type_id" class="form-control">
                <option v-for="t in requestTypes" :value="t.id">{{ t.title }}</option>
              </select>
            </div>
            <LoadingButton
              title="Сохранить"
              type="button"
              :loading="btnLoading"
              color="white"
              :onClick="() => saveRequest()"
              className="btn btn-success"
            />
          </div>
        </template>
      </v-popover>
    </div>
  </div>
</template>

<script>

import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton, DrugSearchNew},
  props: ['data', 'closeDrawer'],
  data() {
    return {
      btnLoading: false,
      requestTypes: this.$platformConstants.customerRequestStatuses,
      newData: {
        city_id: 0,
        type_id: 1,
        comment: null,
        record_id: null,
        client: {
          name: '',
          phone_num: '',
          phone_id: null,
          to_phone_id: null,
        },
        drug: {
          title: '',
          id: ''
        }
      }
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters["orders/editNewOrder"];
    },
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  mounted() {
    if (this.data.searchClient) {
      this.newData.client.name = this.$editNewOrder?.client?.name ?? null;
      this.newData.client.phone_num = this.$editNewOrder?.client?.phones?.[0].search_phone ?? null;
      this.newData.client.phone_id = this.$editNewOrder?.client?.phones?.[0].phone_id ?? null;
      if (this.$editNewOrder?.drugs?.[0]?.id) {
        this.$refs.drugSearch.drug = {id: this.$editNewOrder.drugs[0].id, title: this.$editNewOrder.drugs[0].title}
        this.newData.drug = {
          id: this.$editNewOrder.drugs[0].id,
        }
      }
    } else {
      this.newData.client.name = this.data?.client?.name ?? null;
      this.newData.client.phone_num = this.data?.call?.phone_num ?? null;
      this.newData.client.phone_id = this.data?.call?.phone_id ?? null;
      this.newData.client.to_phone_id = this.data?.call?.to_phone_id ?? null;
      this.newData.record_id = this.data?.call?.record_id ?? null;
    }
  },
  methods: {
    async saveRequest() {
      if ([1, 2, 3, 4].includes(+this.newData.type_id) && !this.newData.drug.title && !this.newData.drug.id) {
        toastr['warning']('Укажите препарат, которого нет в наличии')
        return;
      }

      if ([4].includes(+this.newData.type_id) && !+this.newData.city_id) {
        toastr['warning']('Укажите город клиента')
        return;
      }

      this.btnLoading = true;
      const {data} = await api.post('/new/drugs/client/request', {
        request: this.newData
      })
      if (data.success) {
        toastr['success'](data.message || 'сохранено', 'Успешно')
        if (this.closeDrawer) this.closeDrawer(null, true);
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.btnLoading = false;
    }
  }
}

</script>

<style scoped>
h6 {
  font-weight: bold;
}
</style>
